import {
    METAMODEL_NODE_TYPE,
    transformMetaModelNodesToList,
} from '../../campaigns/modules/campaigns-reports/services/dynamicReportsService';

const RETRY_ATTEMPTS = 2;
const HOUR = 60 * 60 * 1000;

export const DYNAMIC_REPORT_META_MODEL_QUERY_PREFIX = 'DYNAMIC_REPORT_META_MODEL_QUERY_PREFIX';
export const getMetaModelQueryKey = accountName => [DYNAMIC_REPORT_META_MODEL_QUERY_PREFIX, accountName];

export const METAMODEL_QUERY_OPTIONS = {
    retry: RETRY_ATTEMPTS,
    cacheTime: HOUR,
    staleTime: HOUR,
};

export const fetchAndTransformMetaModel = async ({ dynamicReportApi, accountName, metaModelType, excludeNodeList }) => {
    const result = await dynamicReportApi.getMetaModel(accountName, metaModelType);
    const nodeValues = result?.report?.nodes?.values || [];

    return {
        ...result,
        dimensions: transformMetaModelNodesToList(nodeValues, METAMODEL_NODE_TYPE.ROW, excludeNodeList),
        metrics: transformMetaModelNodesToList(nodeValues, METAMODEL_NODE_TYPE.COLUMN, excludeNodeList),
    };
};
